import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import { Shadows } from '@picsart/design-system/foundation/shadows';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';

// Roomy enough for a full preset title plus its category, without letting the
// field swallow the header. The compact width takes over below `lg`, where the
// header also has the Pricing pill and Sign In to fit.
const FIELD_WIDTH = 420;
const FIELD_WIDTH_COMPACT = 320;
const POPOVER_MAX_HEIGHT = 480;

const useStyles = createUseStyles(
  {
    /**
     * Hidden below `sm`, where the header has no room for a field beside the
     * logo and the auth cluster. There the header shows `HeaderSearchLink`
     * instead, and `/search` has a field of its own (`SearchPageField`).
     */
    root: {
      display: 'none',
      position: 'relative',
      alignItems: 'center',
      width: FIELD_WIDTH,
      maxWidth: '100%',
      /**
       * Claims the free space in the header's `space-between` row, which puts
       * the field hard against the auth cluster instead of floating midway
       * between it and the logo. The two then read as one strip of controls —
       * field, then Pricing.
       */
      marginLeft: 'auto',
      [`@media (min-width: ${Breakpoints.sm}px)`]: {
        display: 'flex',
      },
      [`@media (max-width: ${Breakpoints.lg - 1}px)`]: {
        width: FIELD_WIDTH_COMPACT,
      },
    },

    // Layout only. The DS owns the field's border, radius, and background — it
    // renders them on the inner input, so any radius/overflow here clips that
    // border instead of shaping it.
    field: {
      width: '100%',
    },
    popover: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      marginTop: Spacings.s8,
      maxHeight: POPOVER_MAX_HEIGHT,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      // Same radius the DS gives `TextField`, so field and popover read as one
      // control rather than two shapes.
      borderRadius: CornerRadius.r8,
      backgroundColor: BackgroundColors.popover,
      boxShadow: Shadows.tint2,
      zIndex: StackingContext.popover,
    },
    // The moderation message — a sentence, not a state with its own illustration.
    message: {
      margin: 0,
      padding: Spacings.s16,
      fontSize: FontSizes.t4,
      lineHeight: `${LineHeights.t4}px`,
      color: TextColors.tint2,
      textAlign: 'center',
    },
  },
  { name: 'search-dropdown' },
);

export default useStyles;
